// @ts-ignore
/* eslint-disable */
import { request } from 'src/utils/request';

export async function getDeviceList(params: { ipcDevice?: boolean; isAll?: boolean }, options?: { [key: string]: any }) {
  return request<Record<string, any>>(`/api/v1/ipc/devices`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    params: { ...params },
    ...(options || {}),
  });
}
